import React, { useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { QuizContext } from "../../App";
import ButtonCancelAndHideAlert from "../buttons/ButtonCancelAndHideAlert";
import FormContact from "../forms/FormContact";
import ButtonSubmitContactSupport from "../buttons/ButtonSubmitContactSupport";

const ModalContact = () => {

  const quizContext = useContext(QuizContext);
  const theme = quizContext.state.theme;

  return (
    <Modal
      data-bs-theme={theme}
      show={quizContext.state.alert}
      onHide={() => quizContext.dispatch({
        type: "hideAlert"
      })}
    >
      <Modal.Header closeButton data-bs-theme={theme}
        className={`${theme}-modal-header`}
      >
        Напишите в службу поддержки
      </Modal.Header>
      <Modal.Body className={`${theme}-modal-body`}>

        {quizContext.state.messageSent === false
          ? <>
            <FormContact />
            {quizContext.state.errorMySQL
              && <p className="error">Что-то пошло не так. Попробуйте позже.</p>
            }
          </>
          : <p>Ваше обращение отправленно.<br /> Мы свяжемся с Вами в ближайшее время.</p>
        }

        {quizContext.state.messageSent === false
          ? <>
            <div style={{ textAlign: "center", marginTop: "15px" }}>
              <ButtonSubmitContactSupport /> <ButtonCancelAndHideAlert />
            </div>
          </>
          : <div style={{ textAlign: "right", marginTop: "15px" }}>
            <button
              className={`${theme}-main-btn`}
              // style={{ marginTop: "0", textAlign: "right" }}
              onClick={() => quizContext.dispatch({
                type: "hideAlert"
              })}
            >
              OK
            </button>
          </div>
        }
      </Modal.Body>
    </Modal>
  )
}

export default ModalContact